import { render, staticRenderFns } from "./BrebAutocompleteLocation.vue?vue&type=template&id=b65f6fdc&scoped=true&"
import script from "./BrebAutocompleteLocation.vue?vue&type=script&lang=js&"
export * from "./BrebAutocompleteLocation.vue?vue&type=script&lang=js&"
import style0 from "./BrebAutocompleteLocation.vue?vue&type=style&index=0&id=b65f6fdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65f6fdc",
  null
  
)

export default component.exports